<script lang="ts">
  import {getContext, onMount} from 'svelte';
  import {TradeEarnVals$, getStrategySummer} from '../streams';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  onMount(() => {
    getStrategySummer();
  });
</script>

<style lang="scss">
  .wrap {
    margin: 100px auto 0;
    width: 1200px;
    .mv0 {
      margin-top: 0;
      margin-bottom: 0;
    }
    .earn-box {
      display: flex;
      flex-wrap: wrap;
      border-radius: 20px;
      outline: 1px solid #454952;
      overflow: hidden;
      &-item {
        box-sizing: border-box;
        padding: 40px;
        width: 50%;
        height: 50%;
        &:nth-child(3),
        &:nth-child(4) {
          border-top: 1px solid #454952;
        }
        &:nth-child(2),
        &:nth-child(4) {
          border-left: 1px solid #454952;
        }
        h4 {
          margin: 0;
        }
        .udn {
          user-drag: none;
          -webkit-user-drag: none;
        }
        .c-gray {
          color: #b0b2b8;
        }
        .mheight-limit {
          height: 42px;
        }
        .link-trade {
          text-wrap: nowrap;
          &:hover {
            color: #fff;
            opacity: 0.8;
          }
          i {
            transform: rotate(270deg) translateX(-1px);
          }
        }
        &-data {
          display: flex;
          & > div:last-child {
            position: relative;
            &:before {
              position: absolute;
              top: 0;
              left: 0;
              width: 1px;
              height: 100%;
              background: #2c2c2c;
              content: '';
            }
          }
        }
      }
    }
    .earn-box-item {
      min-width: 450px;
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      margin-top: 40px;
      padding: 0 16px;
      width: auto;
      .title {
        font-size: 18px;
      }
      .earn-box {
        margin-top: 20px;
        outline: none;
        gap: 20px;
        .earn-box-item {
          min-width: 300px;
          flex: 1;
          border: 1px solid #454952;
          border-radius: 20px;
          padding: 20px;
          width: 100%;
          &-title {
            font-size: 14px;
          }
          &-desc {
            line-height: 16px;
            font-size: 12px;
          }
          &-data {
            margin-top: 20px;
            .val {
              font-size: 14px;
            }
            .text {
              font-size: 12px;
            }
          }
          .main-image {
            margin-top: 20px;
            img {
              height: 200px;
            }
          }
        }
      }
    }
  }
</style>

<div class="wrap TW">
  <h1 class="mv0 fw3 f32 tc title">{LG(lang.TradeEarn)}</h1>
  <div class="earn-box mt24">
    {#each $TradeEarnVals$ as item}
      <div class="earn-box-item">
        <h4 class="fw3 f24 earn-box-item-title">{LG(item.title)}</h4>
        <div class="fw1 f14 c-gray mt8 lh22 mheight-limit earn-box-item-desc">
          <span>{LG(item.subTitle, {FuturesPairs: item.pairsNum, SpotPairs: item.pairsNum, Leverage: item.leverage})}</span>
          <a class="cp TW link-trade" href={item.linkUrl} rel="noopener noreferrer nofollow">{LG(item.linkTxt)}<i class="iconfont arrow dib fw3">&#xe623;</i></a>
        </div>
        <div class="df aic jcc mt40 main-image">
          <img class="usn udn" src={item.img} height="320px" alt="eran img" />
        </div>
        <div class="mt40 earn-box-item-data">
          <div class="df fdc jcc aic f1">
            <span class="fw2 f20 val">{item.firstVal || '--'}</span>
            <span class="fw1 f14 c-gray text">{LG(item.firstText)}</span>
          </div>
          <div class="df fdc jcc aic f1">
            <span class="fw2 f20 val">{item.secondVal || '--'}</span>
            <span class="fw1 f14 c-gray text">{LG(item.secondText)}</span>
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>
